const activityEventNotificationStatus = {
    NEW : 0,

    VIEWED : 1

};

angular.module('gw-um-j2js')
    .constant('activityEventNotificationStatus', activityEventNotificationStatus);